export default __webpack_public_path__ + "static/media/Discount.5c9c384c.svg";